var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0497 4.86414C7.64246 2.27143 11.2272 0.666016 15.1849 0.666016C19.1426 0.666016 22.7273 2.27143 25.3201 4.86415C27.9128 7.4569 29.5182 11.0416 29.5182 14.9993C29.5182 18.9571 27.9128 22.5418 25.3201 25.1345C22.7273 27.7273 19.1426 29.3327 15.1849 29.3327C11.2272 29.3327 7.64246 27.7273 5.0497 25.1345C2.45698 22.5418 0.851562 18.9571 0.851562 14.9993C0.851562 11.0416 2.45699 7.4569 5.0497 4.86414ZM15.1849 2.66602C11.7789 2.66602 8.69693 4.04538 6.4639 6.27837C4.23091 8.5114 2.85156 11.5934 2.85156 14.9993C2.85156 18.4053 4.23092 21.4873 6.46391 23.7203C8.69693 25.9533 11.7789 27.3327 15.1849 27.3327C18.5909 27.3327 21.6729 25.9533 23.9059 23.7203C26.1389 21.4873 27.5182 18.4053 27.5182 14.9993C27.5182 11.5934 26.1389 8.51139 23.9059 6.27836C21.6729 4.04538 18.5909 2.66602 15.1849 2.66602Z",
    fill: "#18A4EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1849 6.33268C16.1054 6.33268 16.8516 7.07888 16.8516 7.99935C16.8516 8.91982 16.1054 9.66602 15.1849 9.66602C14.2644 9.66602 13.5182 8.91982 13.5182 7.99935C13.5182 7.07888 14.2644 6.33268 15.1849 6.33268Z",
    fill: "#18A4EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1849 12.3327C13.1849 11.7804 13.6326 11.3327 14.1849 11.3327H15.5182C16.0705 11.3327 16.5182 11.7804 16.5182 12.3327V21.666C16.5182 22.2183 16.0705 22.666 15.5182 22.666C14.9659 22.666 14.5182 22.2183 14.5182 21.666V13.3327H14.1849C13.6326 13.3327 13.1849 12.885 13.1849 12.3327Z",
    fill: "#18A4EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1849 21.666C12.1849 21.1137 12.6326 20.666 13.1849 20.666H17.8516C18.4038 20.666 18.8516 21.1137 18.8516 21.666C18.8516 22.2183 18.4038 22.666 17.8516 22.666H13.1849C12.6326 22.666 12.1849 22.2183 12.1849 21.666Z",
    fill: "#18A4EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5dc39fbd.svg";
export { ForwardRef as ReactComponent };